$(document).ready(function () {
    new fullpage('#fullpage', {
        navigation: true,
        anchors:['slide1', 'slide2', 'slide3'],
        sectionsColor: ['transparent'],
        licenseKey: 'F4FE0FC5-99FB444D-BD1AEDA7-89BFE4C5'
    });
});
